import "../styles/HomeNew.css";

export default function NewsLetter() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "42svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Stay <span className="hero__accent">Connected</span>
            </h1>
            <p className="hero__sub">
              Get the latest news, stories, and updates from FBT delivered straight
              to your inbox. Join our mailing list and never miss a moment.
            </p>
            <div className="hero__ctas">
              <a
                href="http://eepurl.com/df3ucr"
                target="_blank"
                rel="noopener noreferrer"
                className="cta cta--solid"
              >
                Join Our Mailing List
              </a>
              <a
                href="https://us17.campaign-archive.com/home/?u=faa074c9464527b3f9b8f1adb&id=1fb80dc979"
                target="_blank"
                rel="noopener noreferrer"
                className="cta cta--ghost"
              >
                Browse Past Issues ↗
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── NEWSLETTER CARDS ── */}
      <section className="events" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Updates & Stories</span>
          <h2 className="sec-h2">Our Newsletters</h2>
          <p className="sec-sub">
            Read about our programs, partner projects, community events, and the people making a difference.
          </p>
        </div>

        <div className="events__grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>

          {/* Join list card */}
          <a
            href="http://eepurl.com/df3ucr"
            target="_blank"
            rel="noopener noreferrer"
            className="ecard card--purple"
          >
            <div className="ecard__icon">📬</div>
            <div className="ecard__img" style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--pu-100)", fontSize: "4rem",
            }}>
              ✉️
            </div>
            <span className="ecard__label">Subscribe</span>
            <h3 className="ecard__name">Join Our Mailing List</h3>
            <p className="ecard__desc">
              Sign up to receive FBT newsletters, event announcements, and impact stories directly in your inbox.
            </p>
            <span className="ecard__arrow">Subscribe now →</span>
          </a>

          {/* Archive card */}
          <a
            href="https://us17.campaign-archive.com/home/?u=faa074c9464527b3f9b8f1adb&id=1fb80dc979"
            target="_blank"
            rel="noopener noreferrer"
            className="ecard card--pink"
          >
            <div className="ecard__icon">📰</div>
            <div className="ecard__img" style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--pk-100)", fontSize: "4rem",
            }}>
              🗂️
            </div>
            <span className="ecard__label">Archive</span>
            <h3 className="ecard__name">Current & Past Newsletters</h3>
            <p className="ecard__desc">
              Browse our full archive of newsletters to catch up on FBT's journey, milestones, and community impact over the years.
            </p>
            <span className="ecard__arrow">Browse archive →</span>
          </a>
        </div>
      </section>

      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>"Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders."</p>
      </div>

    </div>
  );
}